// extracted by mini-css-extract-plugin
module.exports = {"ReportLoadingContainer":"fffd5lt1","reportLoader":"_1y23cr4m"};